module.exports = require("./fr-CD.js");